import React from 'react'
import { BookOpen, ClipboardCheck, Sparkles, FileText, Map, GraduationCap } from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import FeatureGrid from '../FeatureGrid'
import { AI_ASSISTANT } from '../data'
const ICONS = { BookOpen, ClipboardCheck, Sparkles, FileText, Map, GraduationCap }
export default function AIAssistant() {
  return (
    <section className="relative py-24 md:py-28">
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>AI Trading Assistant</Eyebrow>
          <SectionHeading align="center"
            title={<>Your senior analyst — <span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">at every step.</span></>}
            subtitle="The mentor is embedded across the trading platform. It explains, reviews, suggests and summarises — but it never trades for you unless you explicitly ask."
          />
        </div>
        <FeatureGrid items={AI_ASSISTANT} icons={ICONS} cols={3} />
      </Container>
    </section>
  )
}
